import { createContext } from "react";

export const ShareContext = createContext();
